import React from 'react';
import Typography from '@material-ui/core/Typography';
import { Card, CardContent, List, ListItem, ListItemText } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Collapse from '@material-ui/core/Collapse';
import CardActions from '@material-ui/core/CardActions';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
    root: {
        width: '100%',
        maxWidth: 500,
        margin: '0 0 30px',
        padding: '0',
    },
    card: {
        // maxHeight: 500,
        // overflow: 'auto'
    },
    firstPart: {
        paddingBottom: 0
    },
    secondPart: {
        paddingTop: 0,
        paddingBottom: 0
    },
    title: {
        fontSize: '18px',
        textAlign: 'center',
        margin: 0,
        padding: '10px 0',
    },
    list: {
        margin: 0,
        padding: 0
    },
    listItem: {
        margin: 0,
        padding: 0
    },
    listText: {
        margin: 0,
        padding: '10px 0',
        textIndent: '20px'
    },
    listTextItalic: {
        margin: 0,
        padding: '10px 0',
        textIndent: '20px',
        fontStyle: 'italic'
    },
    text: {
        margin: 0,
        padding: '10px 0',
        textAlign: 'justify',
        textIndent: '20px'
    },
    action: {
        paddingTop: 0,
        paddingBottom: 0
    },
    expand: {
        color: '#007bff',
        // padding: 0,
        '&:focus': {
            outline: 'none'
        }
    },
    expandOpen: {
        // transform: 'rotate(180deg)',
    },
});

const JoiningExpenses = () => {
    const classes = useStyles();
    const [expanded, setExpanded] = React.useState(false);
    const handleExpandClick = () => {
        setExpanded(!expanded);
    };

    const expandMoreButton = !expanded ? <Button
        className={clsx(classes.expand, {
            [classes.expandOpen]: expanded,
        })}
        onClick={handleExpandClick}
        aria-expanded={expanded}
        aria-label="show more"
    >
        <span className={classes.expand}>Читати далі</span>
    </Button> : null;

    return (
        // <Card id="expenses" className={classes.card}>
        //     <CardContent className={classes.firstPart} >
            <div>
                {/* <Typography variant="h3" className={classes.title} gutterBottom>
                    Вартість технічного та інформаційно-консультаційного
                        супроводу<br />
                    Програмного комплексу<br />
                    «Інтегрована інформаційна система «Соціальна громада»
                </Typography> */}

                <Typography variant="body1" className={classes.text} gutterBottom>
                    Вартість технічного та інформаційно-консультаційного супроводу програмного комплексу «Інтегрована інформаційна система «Соціальна громада» (ПК «ІІС «Соціальна громада») складається з <b>двох складових</b>:
                </Typography>
                <Typography variant="body1" className={classes.text} gutterBottom>
                    1)	послуги із забезпечення працездатності програмного комплексу «Криптосервер: Модуль шифрування»;
                </Typography>

                <Typography variant="body1" className={classes.text} gutterBottom>
                    2)	послуги з інформаційно-консультаційної підтримки/супроводження користувачів ПК «ІІС «Соціальна громада».
                </Typography>
            {/* </CardContent> */}
            {/* <CardActions className={classes.action}>
                {expandMoreButton}
            </CardActions> */}
            {/* <Collapse in={expanded} timeout="auto" unmountOnExit> */}
                {/* <CardContent className={classes.secondPart}> */}
                    <Typography variant="body1" className={classes.text} gutterBottom>
                        <b>Перша складова:</b>
                    </Typography>
                    <Typography variant="body1" className={classes.text} gutterBottom>
                        Послуги із забезпечення працездатності програмного комплексу «Криптосервер: Модуль шифрування» (МШ), що використовується для захисту інформації, яка передається засобами електронного зв’язку, залежить від кількості необхідних МШ.
                    </Typography>
                    <Typography variant="body1" className={classes.text} gutterBottom>
                        Один МШ встановлюється на одну фізичну локальну мережу. Кількість МШ залежить від того, наскільки розгалужена територіальна громада (об’єднана територіальна громада), а саме, від кількості ЦНАП-ів, старостатів, відділів з питань соціального захисту населення, віддалених робочих місць тощо.
                    </Typography>
                    <Typography variant="body1" className={classes.text} gutterBottom>
                        <b>Вартість одного програмного комплексу «Криптосервер: Модуль шифрування» на рік становить - 1 980,00 грн (з урахуванням ПДВ).</b>
                    </Typography>
                    <Typography variant="body1" className={classes.text} gutterBottom><b>Друга складова:</b></Typography>
                    <List className={classes.list}>
                        <ListItem className={classes.listItem}>
                            <ListItemText className={classes.listText} primary="послуги з інформаційно-консультаційної підтримки/супроводження користувачів  ПК «ІІС «Соціальна громада», які включають надання консультацій щодо;" />
                        </ListItem>
                        <ListItem className={classes.listItem}>
                            <ListItemText className={classes.listText} primary="підключення нових суб’єктів;" />
                        </ListItem>
                        <ListItem className={classes.listItem}>
                            <ListItemText className={classes.listText} primary="питань функціонування ПК «ІІС «Соціальна громада», особливостей його застосування;" />
                        </ListItem>
                        <ListItem className={classes.listText}>
                            <ListItemText className={classes.listText} primary="оновлених версій програмного комплексу з урахуванням законодавчих змін." />
                        </ListItem>
                    </List>
                    <Typography className={classes.text} variant="body1" gutterBottom>
                        <b>Вартість послуги на рік становить - 6 624 грн (з урахуванням ПДВ).</b>
                    </Typography>
                    <Typography className={classes.text} variant="body1" gutterBottom>
                        <b><i>Приклад 1:</i></b>
                    </Typography>
                    <Typography className={classes.text} variant="body1" gutterBottom>
                        <i>Якщо в складі однієї об’єднаної територіальної громади є 1 ЦНАП, 1 старостат та 1 відділ з питань соціального захисту населення, які знаходяться в різних населених пунктах або в різних будівлях, то до кожної з них необхідний окремий модуль шифрування. Тобто, необхідно три МШ:</i>
                    </Typography>
                    <List className={classes.list}>
                        <ListItem className={classes.listItem}>
                            <ListItemText className={classes.listTextItalic} primary="за рік у сумі - 5 940,00 грн (з урахуванням ПДВ) за 3 МШ;" />
                        </ListItem>
                        <ListItem className={classes.listItem}>
                            <ListItemText className={classes.listTextItalic} primary="за місяць у сумі - 165,00 грн (з урахуванням ПДВ) за один Модуль шифрування (МШ)." />
                        </ListItem>
                    </List>
                    <Typography className={classes.text} style={{textAlign: 'left'}} variant="body1" gutterBottom>
                        <i>Інформаційно-консультаційна підтримка/супроводження користувачів ПК «ІІС «Соціальна громада»:</i>
                    </Typography>
                    <List className={classes.list}>
                        <ListItem className={classes.listItem}>
                            <ListItemText className={classes.listTextItalic} primary="за рік у сумі - 6 624,00 грн (з урахуванням ПДВ);" />
                        </ListItem>
                        <ListItem className={classes.listItem}>
                            <ListItemText className={classes.listTextItalic} primary="за місяць у сумі - 552,00 грн (з урахуванням ПДВ)." />
                        </ListItem>
                    </List>
                    <Typography className={classes.text} variant="body1" gutterBottom>
                        <i>Незалежно від кількості МШ.</i>
                    </Typography>
                    <Typography className={classes.text} variant="body1" gutterBottom>
                        <i>
                            Загальна вартість - 12 564,00 грн. Де, 5 940,00 грн (послуги із забезпечення працездатності МШ) + 6 624,00 грн (послуги з інформаційно-консультаційної підтримки/супроводження).</i>
                    </Typography>
                    <Typography className={classes.text} variant="body1" gutterBottom>
                        <b><i>Приклад 2:</i></b>
                    </Typography>
                    <Typography className={classes.text} variant="body1" gutterBottom>
                        <i>Якщо всі вищезазначені установи знаходяться в одній будівлі та з'єднані однією фізичною локальною мережею, то для них достатньо одного МШ і вартість складатиме на рік 1 980,00 грн (з урахуванням ПДВ).</i>
                    </Typography>
                    <Typography className={classes.text} variant="body1" gutterBottom>
                        <i>Загальна вартість – 8 604,00 грн. Де, 1 980,00 грн ( послуги із забезпечення працездатності МШ) + 6 624,00 грн (послуги з інформаційно-консультаційної підтримки/супроводження).</i>
                    </Typography>
                {/* </CardContent> */}
                {/* <CardActions>
                    <Button
                        className={clsx(classes.expand, {
                            [classes.expandOpen]: expanded,
                        })}
                        href="#expenses"
                        onClick={handleExpandClick}
                        aria-expanded={expanded}
                        aria-label="show less"
                    >
                        <span className={classes.expand}>Мінімізувати</span>
                    </Button>
                </CardActions> */}
            {/* </Collapse> */}
        {/* </Card> */}
        </div>
    );
}

export default JoiningExpenses;
